import { render, staticRenderFns } from "./TextCommentBubbleMenu.vue?vue&type=template&id=7041ddae&"
import script from "./TextCommentBubbleMenu.vue?vue&type=script&lang=ts&"
export * from "./TextCommentBubbleMenu.vue?vue&type=script&lang=ts&"
import style0 from "./TextCommentBubbleMenu.vue?vue&type=style&index=0&id=7041ddae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports